export { getConfiguration, setConfiguration } from './cache';
